import React from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { makeStyles } from '@material-ui/core/styles';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import WarningIcon from '@material-ui/icons/Warning';
import { useDispatch } from 'react-redux';
import { hideAlert } from '../../store/pageFrame/actions';

const alertTypeMap = {
  ERROR: {
    color: '#D20004',
    icon: <ErrorOutlineIcon />,
  },
  SUCCESS: {
    color: '#47B676',
    icon: <CheckCircleOutlineIcon />,
  },
  WARNING: {
    color: '#FFAB00',
    icon: <WarningIcon />,
  },
};

const useStyles = makeStyles(() => ({
  wrapper: (props: IProps) => ({
    // @ts-expect-error -- This code was written prior to enforcing lint rules
    border: `1px solid ${alertTypeMap[props.type].color}`,
    display: 'flex',
    maxWidth: '634px',
    alignItems: 'center',
    marginTop: '32px',
  }),
  element: (props: IProps) => ({
    // @ts-expect-error -- This code was written prior to enforcing lint rules
    backgroundColor: `${alertTypeMap[props.type].color}`,
    color: 'white',
    width: '56px',
    height: '56px',
    textAlign: 'center',
    marginRight: '24px',
  }),
  icon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
}));

interface IProps {
  type: string;
  message: string;
  id: string;
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const Alert = (props: IProps) => {
  const dispatch = useDispatch();
  const classes = useStyles(props);
  return (
    <ClickAwayListener onClickAway={() => dispatch(hideAlert())}>
      <div id={props.id} className={classes.wrapper}>
        <div className={classes.element}>
          {/* @ts-expect-error -- This code was written prior to enforcing lint rules */}
          <div className={classes.icon}>{alertTypeMap[props.type].icon}</div>
        </div>
        {props.message}
      </div>
    </ClickAwayListener>
  );
};
